import React from 'react';
import { SvgIcon } from '../../components/svgIcon';
import { SvgIconProps } from '../../components/svgIcon/model';

export const PhoneHatchedIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon
      // cacheName="hatched/phone"
      ref={ref as any}
      {...props}
    >
      <g clipPath="url(#clip0_315_137)">
        <mask height="22" id="mask0_315_137" maskUnits="userSpaceOnUse" style={{ maskType: 'alpha' }} width="22" x="3" y="3">
          <path
            d="M4 23.5936C5.45881 18.8554 6.88626 16.072 7.9686 14.3675C8.34509 13.789 8.95685 12.8663 9.74116 11.3964C10.7294 9.55125 10.949 8.73809 11.8901 7.018C12.3137 6.23613 12.9254 5.18843 13.7725 4"
            fill="#FFCEC3"
          />
          <path
            d="M4 23.5936C5.45881 18.8554 6.88626 16.072 7.9686 14.3675C8.34509 13.789 8.95685 12.8663 9.74116 11.3964C10.7294 9.55125 10.949 8.73809 11.8901 7.018C12.3137 6.23613 12.9254 5.18843 13.7725 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 19.3245C4.54902 18.3394 4.97254 17.495 5.30195 16.8226C5.59999 16.1971 6.05489 15.2588 6.55685 14.0079C7.05881 12.7569 7.07449 12.5223 7.49802 11.6623C7.95292 10.724 8.04705 10.7866 8.48623 9.89528C9.05095 8.73809 8.90977 8.62864 9.53721 7.28383C10.0392 6.18922 10.5098 5.46991 10.6823 5.20407C11.0117 4.70368 11.3255 4.29711 11.5764 4"
            fill="#FFCEC3"
          />
          <path
            d="M4 19.3245C4.54902 18.3394 4.97254 17.495 5.30195 16.8226C5.59999 16.1971 6.05489 15.2588 6.55685 14.0079C7.05881 12.7569 7.07449 12.5223 7.49802 11.6623C7.95292 10.724 8.04705 10.7866 8.48623 9.89528C9.05095 8.73809 8.90977 8.62864 9.53721 7.28383C10.0392 6.18922 10.5098 5.46991 10.6823 5.20407C11.0117 4.70368 11.3255 4.29711 11.5764 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 16.0407C4.15686 15.556 4.43921 14.7585 4.84705 13.8202C5.27058 12.8664 5.41176 12.6943 6.10195 11.2088C6.58822 10.1611 6.58822 10.0986 7.15292 8.91011C7.63919 7.87804 7.749 7.6904 8.06273 7.03364C8.39214 6.3456 8.84704 5.31354 9.31762 4"
            fill="#FFCEC3"
          />
          <path
            d="M4 16.0407C4.15686 15.556 4.43921 14.7585 4.84705 13.8202C5.27058 12.8664 5.41176 12.6943 6.10195 11.2088C6.58822 10.1611 6.58822 10.0986 7.15292 8.91011C7.63919 7.87804 7.749 7.6904 8.06273 7.03364C8.39214 6.3456 8.84704 5.31354 9.31762 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 11.9435C4.48627 10.7707 4.94117 9.83243 5.27058 9.20697C5.8196 8.12797 6.10195 7.6745 6.63528 6.64243C7.1843 5.53218 7.57645 4.60958 7.82742 4.01537"
            fill="#FFCEC3"
          />
          <path
            d="M4 11.9435C4.48627 10.7707 4.94117 9.83243 5.27058 9.20697C5.8196 8.12797 6.10195 7.6745 6.63528 6.64243C7.1843 5.53218 7.57645 4.60958 7.82742 4.01537"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 8.61272C4.21961 8.15927 4.43921 7.70577 4.64313 7.22101C4.98823 6.43915 5.09803 6.09513 5.41176 5.42272C5.56862 5.06307 5.80391 4.57831 6.10195 4.01537"
            fill="#FFCEC3"
          />
          <path
            d="M4 8.61272C4.21961 8.15927 4.43921 7.70577 4.64313 7.22101C4.98823 6.43915 5.09803 6.09513 5.41176 5.42272C5.56862 5.06307 5.80391 4.57831 6.10195 4.01537"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 5.28199C4.1098 5.14125 4.26667 4.93797 4.39216 4.68777C4.51764 4.42194 4.59608 4.18738 4.64313 4.01537"
            fill="#FFCEC3"
          />
          <path
            d="M4 5.28199C4.1098 5.14125 4.26667 4.93797 4.39216 4.68777C4.51764 4.42194 4.59608 4.18738 4.64313 4.01537"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M5.19214 23.9063C5.41174 23.5466 5.75684 22.9837 6.10194 22.2487C6.72939 20.9352 6.8235 20.2628 7.3882 18.8398C7.89017 17.5732 8.37644 16.6506 8.64312 16.1658C9.49015 14.5864 9.74115 14.5396 10.7294 12.8038C11.498 11.459 11.3411 11.5059 12.2666 9.84835C13.1293 8.2846 13.396 8.0188 13.9764 6.8929C14.5882 5.68883 14.9803 4.64113 15.1999 4"
            fill="#FFCEC3"
          />
          <path
            d="M5.19214 23.9063C5.41174 23.5466 5.75684 22.9837 6.10194 22.2487C6.72939 20.9352 6.8235 20.2628 7.3882 18.8398C7.89017 17.5732 8.37644 16.6506 8.64312 16.1658C9.49015 14.5864 9.74115 14.5396 10.7294 12.8038C11.498 11.459 11.3411 11.5059 12.2666 9.84835C13.1293 8.2846 13.396 8.0188 13.9764 6.8929C14.5882 5.68883 14.9803 4.64113 15.1999 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M6.72949 23.9063C7.09027 23.4684 7.60792 22.796 8.15692 21.9047C9.14517 20.2941 9.25495 19.5122 10.4157 16.8695C11.0902 15.337 11.4824 14.4614 12.1569 13.2885C12.9726 11.8812 13.1922 11.8187 14.353 9.87961C14.9177 8.95704 15.4824 8.00317 16.0941 6.68962C16.5961 5.61064 16.9412 4.68804 17.1765 4"
            fill="#FFCEC3"
          />
          <path
            d="M6.72949 23.9063C7.09027 23.4684 7.60792 22.796 8.15692 21.9047C9.14517 20.2941 9.25495 19.5122 10.4157 16.8695C11.0902 15.337 11.4824 14.4614 12.1569 13.2885C12.9726 11.8812 13.1922 11.8187 14.353 9.87961C14.9177 8.95704 15.4824 8.00317 16.0941 6.68962C16.5961 5.61064 16.9412 4.68804 17.1765 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M9.01965 23.9063C9.28633 23.3277 9.63142 22.5615 10.0706 21.6702C11.0902 19.5122 11.8902 17.9172 12.0942 17.5419C12.5177 16.7131 13.2549 15.2589 14.2118 13.4762C15.2941 11.4746 15.4823 11.24 16.2667 9.69197C16.8314 8.58171 17.302 7.6122 17.6941 6.8147C18.2274 5.70446 18.6823 4.75058 19.0117 4.01562"
            fill="#FFCEC3"
          />
          <path
            d="M9.01965 23.9063C9.28633 23.3277 9.63142 22.5615 10.0706 21.6702C11.0902 19.5122 11.8902 17.9172 12.0942 17.5419C12.5177 16.7131 13.2549 15.2589 14.2118 13.4762C15.2941 11.4746 15.4823 11.24 16.2667 9.69197C16.8314 8.58171 17.302 7.61221 17.6941 6.8147C18.2274 5.70446 18.6823 4.75058 19.0117 4.01562"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M23.9999 4.39096C22.541 9.12905 21.1136 11.9125 20.0313 13.617C19.6548 14.1956 19.043 15.1182 18.2587 16.5881C17.2705 18.4333 17.0509 19.2464 16.1097 20.9665C15.6862 21.7484 15.0744 22.7961 14.2274 23.9845"
            fill="#FFCEC3"
          />
          <path
            d="M23.9999 4.39096C22.541 9.12905 21.1136 11.9125 20.0313 13.617C19.6548 14.1956 19.043 15.1182 18.2587 16.5881C17.2705 18.4333 17.0509 19.2464 16.1097 20.9665C15.6862 21.7484 15.0744 22.7961 14.2274 23.9845"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M24 8.67541C23.451 9.66058 23.0117 10.505 22.698 11.1774C22.4 11.8029 21.9451 12.7411 21.4431 13.9921C20.9411 15.2431 20.9255 15.4776 20.502 16.3377C20.0471 17.2759 19.9529 17.2134 19.5137 18.1047C18.9333 19.2462 19.0745 19.3713 18.4628 20.7005C17.9608 21.7951 17.4902 22.5144 17.3176 22.7803C16.9882 23.2807 16.6745 23.6872 16.4235 23.9843"
            fill="#FFCEC3"
          />
          <path
            d="M24 8.67541C23.451 9.66058 23.0117 10.505 22.698 11.1774C22.4 11.8029 21.9451 12.7411 21.4431 13.9921C20.9411 15.2431 20.9255 15.4776 20.502 16.3377C20.0471 17.2759 19.9529 17.2134 19.5137 18.1047C18.9333 19.2462 19.0745 19.3713 18.4628 20.7005C17.9608 21.7951 17.4902 22.5144 17.3176 22.7803C16.9882 23.2807 16.6745 23.6872 16.4235 23.9843"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M24 11.9593C23.8431 12.444 23.5608 13.2415 23.1529 14.1798C22.7294 15.1336 22.5882 15.3057 21.898 16.7912C21.4118 17.8389 21.4118 17.9015 20.847 19.0899C20.3608 20.1219 20.251 20.3096 19.9372 20.9664C19.6078 21.6544 19.1529 22.6865 18.6823 24"
            fill="#FFCEC3"
          />
          <path
            d="M24 11.9593C23.8431 12.444 23.5608 13.2415 23.1529 14.1798C22.7294 15.1336 22.5882 15.3057 21.898 16.7912C21.4118 17.8389 21.4118 17.9015 20.847 19.0899C20.3608 20.1219 20.251 20.3096 19.9372 20.9664C19.6078 21.6544 19.1529 22.6865 18.6823 24"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M23.9999 16.0563C23.4979 17.2291 23.043 18.1673 22.7293 18.7928C22.1803 19.8718 21.8979 20.3252 21.3646 21.3573C20.8156 22.4676 20.4234 23.3902 20.1724 23.9844"
            fill="#FFCEC3"
          />
          <path
            d="M23.9999 16.0563C23.4979 17.2291 23.043 18.1673 22.7293 18.7928C22.1803 19.8718 21.8979 20.3252 21.3646 21.3573C20.8156 22.4676 20.4234 23.3902 20.1724 23.9844"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M23.9999 19.3872C23.7802 19.8406 23.5606 20.2941 23.3567 20.7789C23.0116 21.5608 22.9018 21.9048 22.5881 22.5772C22.4312 22.9368 22.1959 23.4216 21.8979 23.9845"
            fill="#FFCEC3"
          />
          <path
            d="M23.9999 19.3872C23.7802 19.8406 23.5606 20.2941 23.3567 20.7789C23.0116 21.5608 22.9018 21.9048 22.5881 22.5772C22.4312 22.9368 22.1959 23.4216 21.8979 23.9845"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M23.9998 22.7179C23.8744 22.8587 23.7332 23.0463 23.592 23.3121C23.4665 23.578 23.3881 23.8125 23.341 23.9846"
            fill="#FFCEC3"
          />
          <path
            d="M23.9998 22.7179C23.8744 22.8587 23.7332 23.0463 23.592 23.3121C23.4665 23.578 23.3881 23.8125 23.341 23.9846"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M22.7921 4.07827C22.5725 4.43793 22.2274 5.00087 21.8823 5.72019C21.2548 7.03372 21.1607 7.70612 20.596 9.12914C20.0941 10.3957 19.6078 11.3184 19.3411 11.8031C18.4941 13.3825 18.2431 13.4294 17.2549 15.1651C16.4863 16.5099 16.6431 16.463 15.7176 18.1206C14.8549 19.6843 14.5882 19.9501 14.0078 21.076C13.3961 22.2801 13.0039 23.3278 12.7843 23.9689"
            fill="#FFCEC3"
          />
          <path
            d="M22.7921 4.07827C22.5725 4.43793 22.2274 5.00087 21.8823 5.72019C21.2548 7.03372 21.1607 7.70612 20.596 9.12914C20.0941 10.3957 19.6078 11.3184 19.3411 11.8031C18.4941 13.3825 18.2431 13.4294 17.2549 15.1651C16.4863 16.5099 16.6431 16.463 15.7176 18.1206C14.8549 19.6843 14.5882 19.9501 14.0078 21.076C13.3961 22.2801 13.0039 23.3278 12.7843 23.9689"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M21.2704 4.07827C20.9096 4.51611 20.392 5.18852 19.843 6.07985C18.8547 7.69049 18.7449 8.47237 17.5842 11.1151C16.9096 12.6475 16.5175 13.5232 15.843 14.696C15.0273 16.1033 14.8077 16.1659 13.6469 18.1049C13.0822 19.0275 12.5175 19.9814 11.9057 21.2949C11.4038 22.3739 11.0587 23.2965 10.8234 23.9846"
            fill="#FFCEC3"
          />
          <path
            d="M21.2704 4.07827C20.9096 4.51611 20.392 5.18852 19.843 6.07985C18.8547 7.69049 18.7449 8.47237 17.5842 11.1151C16.9096 12.6475 16.5175 13.5232 15.843 14.696C15.0273 16.1033 14.8077 16.1659 13.6469 18.1049C13.0822 19.0275 12.5175 19.9814 11.9057 21.2949C11.4038 22.3739 11.0587 23.2965 10.8234 23.9846"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
        </mask>
        <g mask="url(#mask0_315_137)">
          <path
            d="M13.9922 24.1095C19.58 24.1095 24.1098 19.5833 24.1098 14C24.1098 8.41669 19.58 3.8905 13.9922 3.8905C8.40437 3.8905 3.87457 8.41669 3.87457 14C3.87457 19.5833 8.40437 24.1095 13.9922 24.1095Z"
            fill="#FFCEC3"
          />
        </g>
        <path
          d="M14.9933 12.0487C15.023 12.2761 14.9537 12.4739 14.7858 12.6419L12.8147 14.5995C12.7257 14.6983 12.6097 14.7825 12.4664 14.8516C12.3231 14.9208 12.1824 14.9653 12.0441 14.9851C12.0342 14.9851 12.0045 14.9876 11.9551 14.9926C11.9057 14.9975 11.8415 15 11.7625 15C11.5747 15 11.2708 14.9679 10.8509 14.9036C10.431 14.8393 9.91722 14.6811 9.30961 14.429C8.70186 14.1769 8.01272 13.7987 7.24206 13.2945C6.4714 12.7903 5.65129 12.0982 4.7818 11.2182C4.09017 10.536 3.51709 9.88346 3.06259 9.2606C2.60808 8.6377 2.2425 8.06178 1.96585 7.53283C1.68917 7.00387 1.48168 6.52435 1.34335 6.09427C1.20502 5.66419 1.11116 5.29342 1.06175 4.98198C1.01235 4.67054 0.99259 4.42584 1.00247 4.24788C1.01235 4.06991 1.01729 3.97104 1.01729 3.95127C1.03705 3.81285 1.08151 3.67196 1.15068 3.5286C1.21984 3.38524 1.30383 3.26906 1.40263 3.18008L3.3738 1.20763C3.51213 1.06921 3.67022 1 3.84807 1C3.97652 1 4.09014 1.03708 4.18895 1.11123C4.28775 1.18538 4.37174 1.27684 4.4409 1.38559L6.02673 4.39618C6.11565 4.55437 6.14036 4.72739 6.10083 4.91525C6.06131 5.1031 5.97733 5.26129 5.84888 5.38982L5.12266 6.11652C5.1029 6.13629 5.08561 6.16842 5.07079 6.21291C5.05596 6.25741 5.04855 6.29448 5.04855 6.32414C5.08808 6.53177 5.177 6.76906 5.31533 7.03601C5.4339 7.27329 5.61669 7.56249 5.8637 7.90359C6.11071 8.24469 6.46147 8.63767 6.91598 9.08259C7.3606 9.53744 7.75582 9.89085 8.10164 10.143C8.44739 10.395 8.73649 10.5805 8.96869 10.6991C9.20088 10.8178 9.37873 10.8895 9.50221 10.9141L9.68742 10.9512C9.70718 10.9512 9.73937 10.9438 9.78378 10.929C9.82825 10.9141 9.86036 10.8968 9.88014 10.877L10.7249 10.0169C10.9029 9.85869 11.1102 9.7796 11.3474 9.7796C11.5154 9.7796 11.6487 9.80923 11.7475 9.86858H11.7623L14.6227 11.5593C14.8303 11.6879 14.9538 11.851 14.9933 12.0487Z"
          fill="none"
          stroke="#FF7870"
        />
      </g>
    </SvgIcon>
  );
});
